import { FC } from 'react';

import { useSelector } from 'react-redux';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import { BotaoCancelar } from '../Botao/BotoesComuns';
import { Situacao, TransicaoSituacaoComplexa } from 'model/solicitacao/Situacao';
import styled from 'styled-components';
import { Botao } from '../Botao/Botao';
import { MensagensErroServidor } from '../MensagensErroServidor/MensagensErroServidor';
import { SolicitacaoCorrenteSelector } from 'store/SolicitacaoCorrente/SolicitacaoCorrente.selector';


export interface ConfirmacaoMudancaSituacaoModalProps {
  isAberto: boolean;
  transicao: TransicaoSituacaoComplexa;
  onConfirmado: (situacao: Situacao) => void;
  onClose: () => void;
}


export const ConfirmacaoMudancaSituacaoModal: FC<ConfirmacaoMudancaSituacaoModalProps> = ({isAberto, transicao, onConfirmado, onClose}) => {
  const erros = useSelector(SolicitacaoCorrenteSelector.formulario.erros);
  const isCarregando = useSelector(SolicitacaoCorrenteSelector.formulario.isCarregando);

  const onConfirmadoCallback = async () => {
    await onConfirmado(transicao?.destino);
    onClose();
  }

  const aparencia = transicao.tipo === 'warning'
    ? transicao.tipo
    : undefined;
  
  return <>
    <ModalTransition>
      {(isAberto && transicao.confirmarTransicao !== undefined) &&
        <Modal
          onClose={onClose}
          heading={transicao.confirmarTransicao.titulo}
          appearance={aparencia}
        >
          <MensagensErroServidor erro={erros} retry={onConfirmadoCallback} />
          { transicao.confirmarTransicao.mensagem }

          <Footer>
            <Botao
              isLoading={isCarregando}
              tipo={transicao.tipo}
              type="button"
              onClick={onConfirmadoCallback}>
                {transicao.confirmarTransicao.nomeBotaoConfirmacao}
              </Botao>
            <BotaoCancelar disabled={isCarregando} type="button" onClick={onClose}>{transicao.confirmarTransicao.nomeBotaoCancelar}</BotaoCancelar>
          </Footer>
        </Modal>
      }
    </ModalTransition>
  </>;
}

const Footer = styled.footer`
  text-align: end;
  padding: 1em;
  padding-bottom: 2em;
`;
